<template lang="html">
  <div class="row">
    <div class="col-md-12">
      <div class="wizard-container">
        <div style="display:flex;flex-wrap:wrap;justify-content:center;">
          <div class="wizard-item-container">
            <div
              class="wizard-item"
              v-bind:class="{ active: $route.name == 'valuation-summary' }"
            >
              <div class="wizard-link">
                <a
                  href="#"
                  @click.prevent="navigateTo('valuation-summary')"
                  title="Summary"
                  >1</a
                >
              </div>
            </div>
            <p>Summary</p>
          </div>
          <div class="wizard-line"></div>
          <div class="wizard-item-container">
            <div
              class="wizard-item"
              v-bind:class="{ active: $route.name == 'valuation-comparable' }"
            >
              <div class="wizard-link">
                <a href="#" @click.prevent="navigateTo('valuation-comparable')"
                  >2</a
                >
              </div>
            </div>
            <p>Comparables</p>
          </div>
          <div class="wizard-line"></div>
          <div class="wizard-item-container">
            <div
              class="wizard-item"
              v-bind:class="{ active: $route.name == 'valuation-inspection' }"
            >
              <div class="wizard-link">
                <a href="#" @click.prevent="navigateTo('valuation-inspection')"
                  >3</a
                >
              </div>
            </div>
            <p>Inspection</p>
          </div>
          <div class="wizard-line"></div>
          <div class="wizard-item-container">
            <div
              class="wizard-item"
              v-bind:class="{ active: $route.name == 'valuation-photos' }"
            >
              <div class="wizard-link">
                <a href="#" @click.prevent="navigateTo('valuation-photos')"
                  >4</a
                >
              </div>
            </div>
            <p>Photos</p>
          </div>
          <div class="wizard-line"></div>
          <div class="wizard-item-container">
            <div
              class="wizard-item"
              v-bind:class="{ active: $route.name == 'valuation-drafts' }"
            >
              <div class="wizard-link">
                <a href="#" @click.prevent="navigateTo('valuation-drafts')"
                >
                  5
                </a>
              </div>
            </div>
            <p>Drafts</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
export default {
  methods: {
    navigateTo(page) {
      // prevent uncaught promise
      // cannot navigate to same page
      if (this.$route.name === page) return;

      this.$router.push({
        name: page,
        params: { id: this.$route.params.id },
      });
    },
  },
};
</script>
<style>
</style>
